/*
 * File: SocialLinks.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Render links to company social media pages
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Avatar from "@material-ui/core/Avatar";
import UITextHeader from "components/ui/UITextHeader";
import youtubeIcon from "images/icon-youtube.png";
import twitterIcon from "images/icon-twitter.png";
import facebookIcon from "images/icon-facebook.png";

const styles = {
  gridListTile: {
    textAlign: "center",
    width: "33%"
  },
  avatar: {
    width: 64,
    height: 64,
    display: "block",
    margin: "20px auto"
  }
};

const socialIcons = {
  facebook: {
    url: "https://www.facebook.com/MacPractice",
    src: facebookIcon,
    alt: "Facebook"
  },
  twitter: {
    url: "https://www.twitter.com/MacPractice",
    src: twitterIcon,
    alt: "Twitter"
  },
  youTube: {
    url: "https://www.youtube.com/user/macPractice",
    src: youtubeIcon,
    alt: "YouTube"
  }
};

const Icons = withStyles(styles)(({ classes }) => {
  return Object.keys(socialIcons).map((key, idx) => {
    let icon = socialIcons[key];

    return (
      <GridListTile cols={1} key={idx} className={classes.gridListTile}>
        <a href={icon.url}>
          <Avatar src={icon.src} alt={icon.alt} className={classes.avatar} />
        </a>
      </GridListTile>
    );
  });
});

const SocialLinks = () => (
  <div>
    <UITextHeader title="We're Social!" />
    <GridList cellHeight={160} cols={3}>
      <Icons />
    </GridList>
  </div>
);

export default SocialLinks;
